import React, { FC } from 'react'
import * as mobilbase from '../../api/mobilbase';
import { DeviceMangeResult } from '../../api/mobilbase/models';
import APIRequest from './APIRequest';

const APIRequestSetOutOfOrder: FC<{
    run: boolean, 
    setRun: React.Dispatch<React.SetStateAction<boolean>>, 
    isPending: boolean, 
    setIsPending: React.Dispatch<React.SetStateAction<boolean>>, 
    selectedLocationId: number, 
    selectedDeviceId: number, 
    selectedImage: number, 
    setManageData: React.Dispatch<React.SetStateAction<DeviceMangeResult>>
}> = ({ run, setRun, isPending, setIsPending, selectedLocationId, selectedDeviceId, selectedImage, setManageData }) => {
    return (
        <APIRequest<DeviceMangeResult> 
            run={run} 
            setRun={setRun}
            pending={isPending}
            setIsPending={setIsPending} 
            req={() => mobilbase.postManageDevice({
                locationId: +selectedLocationId,
                deviceId: +selectedDeviceId,
                body: {
                    name: 'I drift',
                    imageNumber: selectedImage,
                }
            })}
            setData={setManageData}
        />
    );
};

export default APIRequestSetOutOfOrder;